export default function useCountdown(targetDateString: string) {
	const targetDate = new Date(targetDateString);
	const now = ref<Date>(new Date());
	const intervalId = ref<NodeJS.Timeout | null>(null);

	const timeLeft = computed(() => {
		const diff = targetDate.getTime() - now.value.getTime();
		if (diff <= 0) return { Tage: 0, Stunden: 0, Minuten: 0, Sekunden: 0 };

		return {
			Tage: Math.floor(diff / (1000 * 60 * 60 * 24)),
			Stunden: Math.floor((diff / (1000 * 60 * 60)) % 24),
			Minuten: Math.floor((diff / 1000 / 60) % 60),
			Sekunden: Math.floor((diff / 1000) % 60),
		};
	});

	const isExpired = computed(() => now.value >= targetDate);

	onMounted(() => {
		requestIdleCallback(() => {
			intervalId.value = setInterval(() => {
				now.value = new Date();
			}, 1000);
		});
	});

	onUnmounted(() => {
		if (intervalId.value) clearInterval(intervalId.value);
	});

	return { timeLeft, isExpired };
}
